/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GSuitConfiguration { 
    client_id?: string | null;
    project_id?: string | null;
    auth_uri?: string | null;
    token_uri?: string | null;
    auth_provider_x509_cert_url?: string | null;
    client_secret?: string | null;
    redirect_uri?: string | null;
    grant_type?: string | null;
    app_name?: string | null;
    page_size?: number;
}

